module.exports = __webpack_public_path__ + "img/nrsc-1-sm.67e7fa86.jpg";